import axios from 'axios'

// 创建一个 Promise 来存储初始化状态
let initializePromise = null;

const baseURL = "https://www.wvwman.com/dev-api"
// 加密函数
const encrypt = (str) => {
    // 简单的字符串混淆
    const key = 'YourSecretKey';  // 可以修改这个密钥
    let encrypted = '';
    for(let i = 0; i < str.length; i++) {
        encrypted += String.fromCharCode(str.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }
    // 转为 Base64
    return btoa(encrypted);
}

// 解密函数
const decrypt = (str) => {
    // Base64 解码
    const decoded = atob(str);
    const key = 'YourSecretKey';  // 使用相同的密钥
    let decrypted = '';
    for(let i = 0; i < decoded.length; i++) {
        decrypted += String.fromCharCode(decoded.charCodeAt(i) ^ key.charCodeAt(i % key.length));
    }
    return decrypted;
}

// 加密的登录信息
const encryptedCredentials = encrypt(JSON.stringify({
    username: 'admin',
    password: "wm2025"
}));

// 登录并初始化函数
const initialize = async () => {
    try {
        // 解密登录信息
        const credentials = JSON.parse(decrypt(encryptedCredentials));
        
        const response = await axios({
            url: `${baseURL}/login`,
            //url: '/dev-api/login',
            method: 'POST',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Accept-Language': 'zh-CN',
                'Content-Type': 'application/json;charset=UTF-8',
                'isToken': 'false'
            },
            data: credentials
        });
        
        if (response.data.code === 200) {
            authToken = response.data.data;
            console.log('登录成功');  // 移除敏感信息的日志
            return authToken;
        }
        throw new Error('登录失败');
    } catch (error) {
        console.error('请求异常');  // 简化错误信息
        throw error;
    }
}

// 创建axios实例
const request = axios.create({
    baseURL: baseURL, // 设置基础URL
    //baseURL: '/dev-api', // 设置基础URL
    timeout: 60000 // 请求超时时间
})

// 存储token
let authToken = '';

// 请求拦截器
/*request.interceptors.request.use(
    async config => {
        // 确保初始化完成
        if (!initializePromise) {
            initializePromise = initialize();
        }
        try {
            await initializePromise;
            if (authToken) {
                config.headers['Authorization'] = `Bearer ${authToken}`;
            }
            return config;
        } catch (error) {
            return Promise.reject(error);
        }
    },
    error => {
        return Promise.reject(error);
    }
)*/

// 响应拦截器
request.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        // 统一处理错误响应
        console.error('请求失败:', error)
        return Promise.reject(error)
    }
)

export default request 